module.exports = __webpack_public_path__ + "img/tree-06-a-leaves.98da53bd.png";